// extracted by mini-css-extract-plugin
module.exports = {"column":"Layout_column__tOHEa","row":"Layout_row__3h6yg"};